import { useState } from "react";
import { Container, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../utils/passwordValidation.js";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    const currentPassword = e.target.currentPassword.value;
    const newPassword = e.target.newPassword.value;
    const confirmPassword = e.target.confirmPassword.value;

    // Validate password
    const passwordValidation = validatePassword(newPassword);
    if (!passwordValidation.isValid) {
      setError(passwordValidation.message);
      setLoading(false);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New passwords do not match");
      setLoading(false);
      return;
    }

    if (currentPassword === newPassword) {
      setError("New password must be different from current password");
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/auth/change-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess("Password changed successfully! Redirecting to dashboard...");
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } else {
        setError(data.message || "Failed to change password");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-4 p-md-5">
          <h2 className="brutal-heading text-center mb-4" style={{ fontSize: "36px" }}>
            CHANGE PASSWORD
          </h2>

          {error && <Alert variant="danger" className="brutal-alert mb-3">{error.toUpperCase()}</Alert>}
          {success && <Alert variant="success" className="brutal-alert mb-3">{success.toUpperCase()}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="brutal-subheading mb-2">CURRENT PASSWORD</Form.Label>
              <Form.Control
                name="currentPassword"
                type="password"
                placeholder="CURRENT PASSWORD"
                className="brutal-form-control"
                required
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="brutal-subheading mb-2">NEW PASSWORD</Form.Label>
              <Form.Control
                name="newPassword"
                type="password"
                placeholder="NEW PASSWORD (MIN 8 CHARS, 1 SPECIAL CHAR)"
                className="brutal-form-control"
                required
                minLength={8}
                disabled={loading}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="brutal-subheading mb-2">CONFIRM NEW PASSWORD</Form.Label>
              <Form.Control
                name="confirmPassword"
                type="password"
                placeholder="CONFIRM NEW PASSWORD"
                className="brutal-form-control"
                required
                minLength={8}
                disabled={loading}
              />
            </Form.Group>

            <Button
              type="submit"
              className="brutal-btn brutal-btn-primary w-100 mb-4"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  CHANGING PASSWORD...
                </>
              ) : (
                "CHANGE PASSWORD"
              )}
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="brutal-link p-0"
              onClick={() => navigate("/dashboard")}
              disabled={loading}
              style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
            >
              BACK TO DASHBOARD
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
